execSelectionSetImpl